import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormBuilder,Validators, FormArray, FormControl } from '@angular/forms';
import { NotificationService } from '../../../../../core/services/notification/notification.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TransactionResult } from '../../../../../core/services/interfaces/transaction-result';
import { IRoles } from '../../Interfaces/IRoles';
import { IScreens } from '../../Interfaces/IScreens';
import { TranslateService } from '../../../../../core/services/translate-service';
import { RolesService } from '../../services/roles-service';
import { TranslateApplicationService } from 'src/app/core/translate/translate-application-service';
import { IRolesScreens } from '../../Interfaces/IRolesScreens';
import { CognitoService } from 'src/app/core/services/cognito/cognito.service';

@Component({
	selector: 'role-detail',
	templateUrl: 'roles-details.component.html',
})
export class RolesDetailsComponent {
	formGroup: FormGroup;
	loading = false;
	ordersData: IScreens[];
	i: number;
	toChange: Array<number> = [];
	toChangeParents: Array<number> = [];
	value: boolean;

	max_characters: string = '';

	get ordersFormArray() {
		return this.formGroup.controls.orders as FormArray;
	}

	constructor(
		private roleService: RolesService,
		private dialogRef: MatDialogRef<RolesDetailsComponent>,
		@Inject(MAT_DIALOG_DATA) public data: IRoles,
		private notificationService: NotificationService,
		public translate: TranslateApplicationService,
		private formBuilder: FormBuilder,
	) {
		this.formGroup = this.formBuilder.group({
			pkrole: [data.pkrole == null ? 0 : data.pkrole],
			txtrole: [
				data.role,
				[
					Validators.required,
					Validators.maxLength(100),
					Validators.pattern('.*[a-zA-Z].*'),
				],
			],
			orders: new FormArray([]),
			available: data.available
		});
	}

	ngOnInit(): void {
		let max_char = this.translate.TranslateKey('max_characteres');
		this.max_characters = max_char.replace('{{ number_max }}', '100');
		this.GetScreens();
	}

	private AddCheckboxes() {
		this.loading = true;
		// 2. Create an array form with the screens, and for each one new form control
		this.ordersData.forEach(() =>
			this.ordersFormArray.push(new FormControl(false)),
		);
		this.i = 0;
		// 3. Set the default value for each element in array form in true
		this.ordersData.forEach((obj) => {
			if (obj.pkrole != 0) {
				this.ordersFormArray.controls[this.i].setValue(true);
			}
			this.i = this.i + 1;
		});
		this.loading = false;
	}

	GetScreens() {
		this.loading = true;
		// 1. Get the screens
		this.roleService.GetScreens(this.formGroup.value).subscribe(
			(result: TransactionResult<IScreens[]>) => {
				this.loading = false;
				if (result.success) {
					this.ordersData = result.data;
					this.AddCheckboxes();
				}
				else{
					this.ErrorAlert(result.message);
				}
			},
			(error: any) => {
				this.ErrorAlert(error);
				this.loading = false;
			},
		);
	}

	Save() {
		let atLeastOneTrue = false;
		this.formGroup.controls.orders.value.forEach((element) => {
			if (element) atLeastOneTrue = true;
		});
		if (atLeastOneTrue) {
			this.i = 0;
			this.ordersData.forEach((obj) => {
				if (obj.mandatory) {
					this.ordersFormArray.controls[this.i].setValue(true);
				}
				this.i = this.i + 1;
			});
			this.loading = true;
			var role = this.formGroup.controls.txtrole.value;
			if (this.formGroup.controls.txtrole.valid && role.trim() != '') {
				if (this.formGroup.controls.pkrole.value == 0) {
					this.roleService.CreateRole(this.formGroup.value).subscribe(
						(result: TransactionResult<IRoles>) => {
							if (result.success) {
								this.roleService.AddRolesScreens(
									result.data,
									this.formGroup.value,).subscribe(
									(results: TransactionResult<IRolesScreens>) => {
										if (results.success) {
											this.loading = false;
											this.Alert();
											this.dialogRef.close(true);
										}
										else{
											this.ErrorAlert(results.message);
											this.loading = false;
										}
									},
									(error) => {
										this.ErrorAlert(error);
										this.loading = false;
									}
								);
							} else {
								//this.ErrorAlert(result.message);
								this.loading = false;
							}
						},
						(error: any) => {
							this.ErrorAlert(error);
							this.loading = false;
							this.dialogRef.close(true);
						},
					);
				} else {
					this.roleService.UpdateRole(this.formGroup.value).subscribe(
						(result: TransactionResult<IRoles>) => {
							if (result.success) {
								this.roleService.AddRolesScreens(
									result.data,
									this.formGroup.value,).subscribe(
									(results: TransactionResult<IRolesScreens>) => {
										if (results.success) {
											this.loading = false;
											this.Alert();
											this.dialogRef.close(true);
										} else {
											this.ErrorAlert(results.message);
											this.loading = false;
											this.dialogRef.close(true);
										}
									},
									(error: any) => {
										this.ErrorAlert(error);
										this.loading = false;
										this.dialogRef.close(true);
									},
								);
							} else {
								//this.ErrorAlert(result.message);
								this.loading = false;
							}
						},
						(error) => {
							this.ErrorAlert(error);
							this.loading = false;
						}
					);
				}
			} else {
				this.notificationService.AddAlert({
					icon: 'all_inbox',
					title: 'Warning',
					message: this.translate.TranslateKey('COMPLETE_FORM'),
					shown: true,
				});
				this.loading = false;
			}
		} else {
			this.loading = false;
			this.notificationService.AddAlert({
				icon: 'all_inbox',
				title: 'Warning',
				message: this.translate.TranslateKey('ROLES.No_screens_selected'),
				shown: true,
			});
		}
	}

	Change(index: number, level: string, pkscreen: number) {
		this.i = 0;
		this.toChange.push(index);
		this.toChangeParents.push(index);
		this.value = false;
		if (this.ordersFormArray.controls[index].value == true)
			this.value = true;

		this.ChangeChildren(this.toChange, level, pkscreen);
		this.ChangeParents(this.toChangeParents, level, pkscreen);
	}

	ChangeChildren(obj: Array<number>, level: string, pkscreen: number) {
		this.toChange = [];
		this.i = 0;
		obj.forEach((primary) => {
			this.ordersData.forEach((obj) => {
				if (obj.pkscreen == this.ordersData[primary].pkscreen) {
					this.i = 0;
					this.ordersData.forEach((obj2) => {
						if (obj.pkscreen == obj2.fkscreenparent) {
							this.ordersFormArray.controls[this.i].setValue(
								this.value,
							);
							this.toChange.push(this.i);
						}
						this.i = this.i + 1;
					});
				}
			});
		});
		if (this.toChange.length > 0)
			this.ChangeChildren(this.toChange, level, pkscreen);
		if (this.toChangeParents.length > 0)
			this.ChangeParents(this.toChangeParents, level, pkscreen);
	}

	ChangeParents(obj: Array<number>, level: string, pkscreen: number) {
		this.toChangeParents = [];
		this.i = 0;
		obj.forEach((primary) => {
			this.ordersData.forEach((obj) => {
				if (obj.pkscreen == this.ordersData[primary].pkscreen) {
					this.i = 0;
					this.ordersData.forEach((obj2) => {
						if (obj.fkscreenparent == obj2.pkscreen) {
							this.ordersFormArray.controls[this.i].setValue(
								true,
							);
							this.toChangeParents.push(this.i);
						}
						this.i = this.i + 1;
					});
				}
			});
		});

		// Buscamos cuando esten deshabilitando y haciendo click sobre un hijo
		if (this.value == false && level == 'child') {
			// filtramos a todos los hijos del padre
			let childs = this.ordersData.filter(
				(element) => element.fkscreenparent == pkscreen,
			);
			let pather = this.ordersData.filter(
				(element) => element.pkscreen == pkscreen,
			);

			let countNotChecked = 0;
			let childslength = childs.length;

			// Evaluar si los hijos están activados
			childs.forEach((child) => {
				let i = 0;
				this.ordersFormArray.controls.forEach((element) => {
					let num = child.pkscreen - 1;
					if (
						i == num &&
						this.ordersFormArray.controls[num].value == false
					) {
						countNotChecked = countNotChecked + 1;
					}
					i = i + 1;
				});
			});

			// Si el contador es igual al largo de los hijos entonces deshabilita el padre
			if (countNotChecked == childslength) {
				this.ordersFormArray.controls[pather[0].pkscreen - 1].setValue(
					false,
				);
			}
		}
		if (this.toChangeParents.length > 0)
			this.ChangeParents(this.toChangeParents, level, pkscreen);
	}

	Close() {
		//this.dialogRef.close(false);
	}

	Alert() {
		this.notificationService.AddAlert({
			icon: 'all_inbox',
			title: 'Success',
			message: this.translate.TranslateKey('COMPLETE'),
			shown: true,
		});
	}

	ErrorAlert(message: any) {
		this.notificationService.AddAlert({
			icon: 'all_inbox',
			title: 'Error',
			message: message,
			shown: true,
		});
	}
}
